import React from 'react';
import WName from '../WName';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, TLDR, Qual} from '../common';

// TRANSACTIONALITY

// ties to hierarchy maybe
export const transactionality = {
  name: "transactionality",
  alternatives: "transactional",
//  prelude: <span>
//  </span>,
  header: <span>
    We are addicted to TRANSACTIONALITY
  </span>,
  outside: <span>
    <TLDR />: if you look at our shared <QL>consciousness</QL> as a <i>single</i> <QL>body</QL> (cf. <AL name="religion.christ">Corous Christi</AL>), transactionality <i>does not make sense</i>. How would a <AL name="handicap">biological</AL> <NW>khet</NW> function if each part had to individually <i>pay</i> for its <QL>derecho de existir</QL>?
  </span>,
  preview: <div className="problem-preview">
    <p>The answer to that one (how would a <QL>body</QL> function if each part had to <PL name="individuality">separately</PL> <i>pay</i> to <LRL>exist</LRL></p>
  [under construction]
  </div>,
//  text: <div className="problem-text">
//  </div>,
};
